import ReactDOM from 'react-dom/client';

import { AppWrapper } from './AppWrapper';
import { HealthCheckRouter } from './routes';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(window.location.pathname === HealthCheckRouter ? <div>Healthy</div> : <AppWrapper />);
